export default "__VITE_ASSET__269S$iTj__"